import { render, staticRenderFns } from "./CoinSelect.vue?vue&type=template&id=4cbccd20&scoped=true&"
import script from "./CoinSelect.vue?vue&type=script&lang=js&"
export * from "./CoinSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbccd20",
  null
  
)

export default component.exports